module.exports = __webpack_public_path__ + "img/market2.f8f472cb.png";